import {
  Box,
  Column,
  Columns,
  Inline,
  Stack,
  useResponsiveValue,
} from 'braid-design-system';
import type { FC } from 'react';

import { Display } from 'src/libs/Display';

type Props = {
  applicantName: JSX.Element;
  recentRole: JSX.Element;
  contactInfo: JSX.Element;
  badges: JSX.Element;
  keyInformation: JSX.Element | null;
  starRatingInput: JSX.Element;
  actionButtons: JSX.Element;
  appliedDate: JSX.Element;
};

export const ProfileHeaderLayout: FC<Props> = ({
  applicantName,
  recentRole,
  contactInfo,
  badges,
  keyInformation,
  starRatingInput,
  actionButtons,
  appliedDate,
}) => {
  const responsiveValue = useResponsiveValue();
  const isDesktopOrAbove = responsiveValue({
    mobile: false,
    desktop: true,
  });

  return (
    <Box data={{ testid: 'profile-header-details' }}>
      <Stack space="medium">
        <Columns space="none">
          <Column>
            <Stack space="medium">
              <Stack space="small">
                {applicantName}
                {recentRole}
                {contactInfo}
              </Stack>

              {badges}
              {keyInformation}
            </Stack>
          </Column>
          <Column width={isDesktopOrAbove ? '1/3' : '1/4'} hideBelow="tablet">
            <Box
              style={{
                height: '100%',
                backgroundImage: `url(https://seekcdn.com/cm-ui/images/${
                  isDesktopOrAbove ? 'SeekShapesDesktop' : 'SeekShapesTablet'
                }.svg)`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top right',
                backgroundSize: 'auto',
                maxHeight: '180px',
                maxWidth: '282px',
                marginLeft: 'auto',
              }}
            />
          </Column>
        </Columns>

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          flexWrap="wrap"
          gap="medium"
        >
          <Box flexGrow={1} marginLeft="none" paddingLeft="none">
            <Inline space="medium" alignY="center">
              {appliedDate}
              {starRatingInput}
            </Inline>
          </Box>
          <Display tablet desktop>
            {actionButtons}
          </Display>
        </Box>
      </Stack>
    </Box>
  );
};
